import countries from '@/constants/country';

export default ({ country = '', number = '' } = {}) => {
  const targetCountry = countries.find(item => item.code === country) || {};
  const countryCode = targetCountry.phone || '';
  if (countryCode && number) return `+${countryCode}${number}`;
  if (number) return number;
  return '';
};
